/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';

/**
 * The dxp segment group entity type.
 */
export type EntitySegmentGroup = io.TypeOf<typeof SegmentGroup>;

export const SEGMENT_GROUP_OPERATOR_LAST_ASSIGNED = `last-assigned`;

export const SEGMENT_GROUP_OPERATOR_PRIORITY = `priority`;

/**
 * The dxp segment group entity definition.
 * @export
 */
export const SegmentGroup = io.type(
  {
    description: io.string,
    name: io.string,
    operator: io.union([io.literal(SEGMENT_GROUP_OPERATOR_LAST_ASSIGNED), io.literal(SEGMENT_GROUP_OPERATOR_PRIORITY)]),
    priority: io.array(io.string),
    segments: io.array(io.string),
  },
  `SegmentGroup`,
);
